import { datadogRum } from '@datadog/browser-rum';
import { DATADOG_ENABLED } from '@m/config/env';
import { isProd } from '@m/config/FeatureFlags';
import { AppName } from '@m/types';
import { User } from '@m/types/api';

const DD_APP_ID = process.env.REACT_APP_DD_APP_ID;
const DD_CLIENT_TOKEN = process.env.REACT_APP_DD_CLIENT_TOKEN;

export function initDatadog(app: AppName) {
  if (DATADOG_ENABLED && DD_APP_ID && DD_CLIENT_TOKEN) {
    datadogRum.init({
      applicationId: DD_APP_ID,
      clientToken: DD_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: `${app}-app`,
      env: process.env.REACT_APP_CONFIG_ENV,

      version: process.env.REACT_APP_VERSION || undefined,
      // Internal apps have about 2K sessions per day (Jan 2025) so we can sample at a higher rate
      // Customer app has about 90K sessions per day (Jan 2025)
      sessionSampleRate: app === 'customer' && isProd ? 5 : 100,
      sessionReplaySampleRate: 10,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
  }
}

export function dataDogSetUser(user: User) {
  if (DATADOG_ENABLED) {
    const { id: userId, email, ...userInfo } = user;
    datadogRum.setUser({
      ...userInfo,
      id: userId.toString(),
      email: email ?? undefined,
    });
  }
}

export function dataDogLogOut() {
  if (DATADOG_ENABLED) {
    datadogRum.clearUser();
  }
}
